export type ClassificationType = "accuracy" | "citation" | "grammar" | "evidence";

export const classifications: Record<ClassificationType, { label: string; description: string }> = {
  "accuracy": {
    label: "Accuracy of Statements",
    description: "Check factual correctness of statements.",
  },
  "evidence": {
    label: "Use of Evidence",
    description: "Verify claims are supported by evidence.",
  },
  "grammar": {
    label: "Grammar and Spelling",
    description: "Identify grammar, spelling, punctuation errors.",
  },
  "citation": {
    label: "Citation Format",
    description: "Ensure citations are advised and formatted properly.",
  }
}